const _ = require('underscore');
const React = require('react');
const GraphPanel = require('./panels/GraphPanel.jsx');
const TextPanel = require('./panels/TextPanel.jsx');
const createReactClass = require("create-react-class");

const Row = createReactClass({
  getInitialState: function() {
    return {
      collapsed: this.props.item.collapse
    };
  },

  toggleRow: function() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  },

  rowClasses: function() {
    let wrapperClassList = "row";
    if (this.state.collapsed) {
      wrapperClassList += " hidden";
    }

    return wrapperClassList;
  },

  render: function() {
    const model = this.props.model;
    const selectedTimeRange = this.props.timeRange;
    const self = this;

    const panels = _.map(this.props.item.panels, function(item) {
      item.data.logUrl = model.LogUrl;

      switch (item.data.panelType) {
        case 'timeseries':
          return (
            <GraphPanel
              key={item.id}
              item={item}
              model={model}
              timeRange={selectedTimeRange}
              showDeployments={self.props.showDeployments}
              showVirtualStacks={self.props.showVirtualStacks}
            />
          );

        case 'text':
          return (
            <TextPanel
              key={item.id}
              item={item}
            />
          );
      }
    });

    return (
      <div className='metric-row'>
        {this.props.item.show_title ? (
            <h5>
              <div onClick={this.toggleRow}>
                <i className={this.state.collapsed ? 'fa fa-chevron-right' : 'fa fa-chevron-down'} />
                {this.props.item.title}
              </div>
            </h5>
        ) : ''}

        <div className={this.rowClasses()}>
          {panels}
        </div>
      </div>
    );
  }
});

module.exports = Row;
